import './style.sass';

import React from 'react';

import TeamCaseItem from './team-case-item';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

const TeamCase = ({ listTeam }) => {
    return (
        <FullWrapper className="team-case">
            {listTeam.map((item, index) => (
                <div key={index} className="team-case__container">
                    <div className="team-case__container-title">{item.title}</div>
                    <TeamCaseItem item={item} />
                </div>
            ))}
        </FullWrapper>
    );
};

export default TeamCase;
